module.exports = __webpack_public_path__ + "media/images/application/placeholder/placeholder-2x1-1ab59d11ef53dacc39170ad850e68c2e.jpg";